import React, { Component } from 'react'
import { observer, inject } from 'mobx-react'
import PropTypes from 'prop-types'
import capitalize from 'lodash/capitalize'

import Row from '@components/Details/Row'

class Contact extends Component {
  static propTypes = {
    sidebarStore: PropTypes.object,
    staticData: PropTypes.object,
    contact: PropTypes.object
  }

  handleSidebarClick = (id, template) => {
    this.props.sidebarStore.openSidebar({
      template,
      id
    })
  }

  render () {
    const { contact } = this.props
    return (
      <div className='group'>
        <Row label='Name' text={contact.fullName} />
        <Row
          label='Office'
          text={contact.client.office.officeName}
          onClick={() =>
            this.handleSidebarClick(contact.client.office.id, 'client-office')
          }
        />
        <Row
          label='Account'
          text={contact.client.account.companyName}
          onClick={() =>
            this.handleSidebarClick(contact.client.account.id, 'client-account')
          }
        />
        {contact.address.phones &&
          contact.address.phones.map(
            phone =>
              phone.phoneNum && (
                <Row
                  key={phone.id}
                  label={`Phone (${capitalize(
                    this.props.staticData.renderPhoneType(phone.phoneTypeId)
                  )})`}
                  text={phone.phoneNum}
                />
              )
          )}
        <Row label='Email' text={contact.email} />
        {contact.address.emails.map(email => (
          <Row key={email.id} text={email.email} />
        ))}
        <Row label='Address' text={contact.address.address1} />
        <Row label='City' text={contact.address.city} />
        <Row label='Postal code' text={contact.address.postalCode} />
        <Row label='State/Province' text={contact.address.state} />
        <Row
          label='Country'
          text={this.props.staticData.renderCountry(contact.address.countryId)}
        />
        <Row
          label='Timezone'
          text={this.props.staticData.renderTimezone(
            contact.address.timezoneId
          )}
        />
      </div>
    )
  }
}

export default inject('sidebarStore', 'staticData')(observer(Contact))
